import { getCookie, setCookie } from 'cookies-next'
import { v4 as uuid } from 'uuid'
import { YEAR_IN_SECONDS } from '../timeInSeconds'

export const COOKIE_NAME = 'optimizely_id'

export const getUserId = context => {
  if (context?.req) {
    const userId = getCookie(COOKIE_NAME, context)

    if (userId) {
      return userId
    }

    const newUserId = uuid()

    setCookie(COOKIE_NAME, newUserId, {
      ...context,
      secure: true,
      sameSite: 'lax',
      expires: new Date(Date.now() + 2 * YEAR_IN_SECONDS * 1000),
    })

    return newUserId
  }

  const userId = getCookie(COOKIE_NAME)

  if (userId) {
    return userId
  }

  const newUserId = uuid()

  setCookie(COOKIE_NAME, newUserId, {
    maxAge: 2 * YEAR_IN_SECONDS,
    secure: true,
    sameSite: 'lax',
  })

  return newUserId
}
